// URL映射表 - 使用Base64编码隐藏真实路径
const urlMap = {
  'posterList': 'L2Zyb250L3Bvc3RlckluZm8vbGlzdA==',
  'categoryList': 'L2Zyb250L2Jvb2tDYXRlZ29yeS9saXN0',
  'bookCategoryConfig': 'L2Zyb250L2Jvb2tDYXRlZ29yeS9nZXRCb29rQ2F0ZWdvcnlDb25maWc=',
  'statistics': 'L2Zyb250L3N0YXRpc3RpY3MvZ2V0U3RhdGlzdGljcw==',


  'bookPage': 'L2Zyb250L2Jvb2tJbmZvL2xpc3RCb29rUGFnZQ==',
  'bookDetail': 'L2Zyb250L2Jvb2tJbmZvL2dldEJvb2tEZXRhaWw=',
  'addReport': 'L3N5c3RlbS9ib29rcmVwb3J0Zm9ybXMvYWRkUmVwb3J0',
  'relatedBook': 'L2Zyb250L2Jvb2tJbmZvL2xpc3RSZWxhdGVkQm9vaw==',
  'bookPdf': 'L2Zyb250L2FydGljbGVJbmZvL2Rvd25sb2FkQXJ0aWNsZQ==',

  'hotTopic': 'L2Zyb250L2FydGljbGVJbmZvL2dldEhvdFRvcGlj',
  'topicType': 'L2Zyb250L2FydGljbGVJbmZvL2xpc3RUb3BpY1R5cGU=',
  'disciplinaryField': 'L2Zyb250L2FydGljbGVJbmZvL2xpc3REaXNjaXBsaW5hcnlGaWVsZA==',
  'articlePage': 'L2Zyb250L2FydGljbGVJbmZvL2xpc3RBcnRpY2xlUGFnZQ==',
  'addReportArticle': 'L3N5c3RlbS9hcnRpY2xlcmVwb3J0Zm9ybXMvYWRkUmVwb3J0',
  'addDownloadReportArticle': 'L3N5c3RlbS9hcnRpY2xlcmVwb3J0Zm9ybXMvYWRkUmVwb3J0',
  'articleDetail': 'L2Zyb250L2FydGljbGVJbmZvL2dldEFydGljbGVEZXRhaWw=',
  'relatedArticle': 'L2Zyb250L2FydGljbGVJbmZvL2xpc3RSZWxhdGVkQXJ0aWNsZQ==',
  'articlePdf': 'L2Zyb250L2FydGljbGVJbmZvL3ByZXZpZXdQZGY=',
};

// Base64解码函数
const decodeUrl = (key) => {
  if (!urlMap[key]) return key;
  try {
    return atob(urlMap[key]);
  } catch (e) {
    console.error('URL decode error:', e);
    return key;
  }
};

export { urlMap, decodeUrl };